import { AlkLogger } from '@alk/core';
import { IMonitoringStream } from '../../interfaces';
import { IMonitoringWithBufferService } from './monitoring-with-buffer.interface';
import { injectable } from 'inversify';

@injectable()
export class MonitoringWithBufferMock implements IMonitoringWithBufferService {
    send(data: IMonitoringStream): void {
        AlkLogger.debug('[MonitoringWithBufferMock#send] Data to send:', data);
    }
}
